import initialProjectBudgetState from './initialProjectBudget';

export default {
    saving: false,
    nextDisabled: false,
    navDisabled: false,
    portfolio: {
        modalOpen: false,
    },
    current: {
        applicationId: '',
        units: [],
        hideButtons: false,
        activeStep: 0,
        activeStepSection: 0,
        constructionOverseers: [],
        displayFinancialLit: false,
        loan: {
            name: '',
            loanType: '',
            loanRequestIsFor: null,
            intendedPurpose: 'sell',
            propertyType: '',
            numberApplyingFor: '',
            generalContractorId: null,
            contractorSelected: false,
            horizontalImprovementsSame: null,
            borrowerEntityId: '',
        },
        legalInformation: {
            firstLoan: null,
            howFound: '',
            currentDefendantExplaination: '',
            currentDefendant: null,
            currentJudgement: null,
            currentJudgementExplaination: '',
            realEstateDelinquincies: null,
            realEstateDelinquinciesExplaination: '',
            taxDelinquincies: null,
            taxDelinquinciesExplaination: '',
            financialWorseOff: null,
            financialWorseOffExplaination: '',
        },
        portfolio: {
            properties: [],
            validPropertyAddresses: [],
            viewing: 0,
        },
        properties: [],
        singlePropertyInfo: null,
        rejectionComments: [],
        onRejectString: '',
        rejected: [],
        company: '',
        brokerUsed: null,
        brokerName: '',
        brokerEmail: '',
        brokerRate: '',
        brokerAdditionalFees: '',
        creditApproverId: null,
        termSheetAgreementTime: null,
        costAck: false,
        supervisoryAck: false,
        allocationDone: false,
        projectBudget: { ...initialProjectBudgetState },
        companyBudgets: [],
        sectionComplete: '0000',
        lineOfCredit: false,
        s1Date: '',
        intendedPurpose: 'sell',
        staleTermsheet: null,
        viewing: {
            propertyIndex: 0,
            propertyAddressForm: false,
        },
    },
    applicationReviewModal: {
        isOpen: false,
    },
    incompleteReviewModal: {
        isOpen: false,
    },
    applicationSummaryModal: {
        isOpen: false,
    },
    appraisalModal: {
        isOpen: false,
    },
    declineOrRecycleModal: {
        isOpen: false,
    },
    rollbackModal: {
        isOpen: false,
    },
    convertToLoanModal: {
        isOpen: false,
    },
    searchText: undefined,
    changeAppLoanTypeModal: {
        isOpen: false,
    },
    editReviewerModal: {
        isOpen: false,
    },
    restoreApplicationModal: {
        isOpen: false,
    },
    movePropertiesModal: {
        isOpen: false,
    },
    auditHistoryModal: {
        isOpen: false,
    },
    principalSwapModal: {
        isOpen: false,
    },
    applicationFilesModal: {
        isOpen: false,
    },
};
